// styles & types & assets
import styles from "./Title.module.scss";
type TProps = {
  children: React.ReactNode;
};
export default function Title({ children }: TProps) {
  return <h1 className={styles["title"]}>{children}</h1>;
}
